import { Environment, getEnvironment } from '@backoffice-frontend/environment'
import { useEffect } from 'react'

export const isTrackingEnabled = (label: string | undefined) => {
  switch (getEnvironment()) {
    case Environment.integration:
      console.info('reporting event with label:', label)
      return true
    case Environment.production:
      return true
    default:
      return false
  }
}

type TrackingProps = {
  action?: string
  category?: string
  label?: string
  value?: number
}
export const trackAnalyticsEvent = (props: TrackingProps) => {
  if (isTrackingEnabled(props.label)) {
    // We currently don't do anything here as we've migrated away from Google Analytics
    // and Cloudwatch RUM. The Backoffice Platform team will soon implement a new tracking solution here.
  }
}

export const trackClickEvent = (label: string) => {
  if (isTrackingEnabled(label)) {
    trackAnalyticsEvent({ action: 'click', label: label })
  }
}

export const useImpressionTracking = (props: Omit<TrackingProps, 'action'>) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: we don't want to re-track really only track once
  useEffect(() => {
    trackAnalyticsEvent({ ...props, action: 'component-impression' })
  }, [])
}
